export default __webpack_public_path__ + "static/media/unsubscribe_okara.77ee3d11.svg";